<template lang="pug">
.media-admin
  .buttons
    button3d(@click="toggleFilter()")
      icon.small(name="filter")
    div(style="flex: 1 0") 
    div Total: {{ total }}
  .filter-panel(v-if="showFilter")
    media-admin-filter(:filter="filter", @runFilter="runFilter")
  media-gallery(:selectedIds.sync="selectedIds", :adminMode="true")

  .buttons
    button3d(@click="toggleActions()")
      icon.small(name="update")
    div(style="margin-left:4vw;flex:1 0;") {{ selectedIds.size || "Keine" }} Medien ausgewählt
    button3d(@click="checkAll") 
      icon.small(name="checked")
  admin-actions(v-if="showActions"
      :selectedIds.sync="selectedIds",
      :visibility.sync="visibility",
      @tagStates="setTagStates",
      @batchUpdate="applyBatchUpdate"
    )
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import MediaAdminFilter from "@/components/MediaAdminFilter.vue";
import AdminActions from "./AdminActions.vue";
import MediaGallery from "./MediaGallery.vue";
import Icon from "@/components/Icon.vue";
import Button3d from "@/components/Button3d.vue";
import api from "@/api";

export default {
  name: "MediaAdmin",
  components: { MediaAdminFilter, AdminActions, MediaGallery, Icon, Button3d },
  data() {
    return {
      showFilter: false,
      showActions: false,
      selectedIds: new Set(),
      visibility: 0,
      tagStates: {},
    };
  },
  computed: {
    ...mapGetters({
      total: "media/total",
      filter: "media/filter"
    }),
  },
  methods: {
    ...mapActions({
      clear: "media/clear",
      load: "media/list",
      batchUpdate: "media/batchUpdate",
    }),
    toggleFilter() {
        this.showFilter = !this.showFilter;
    },
    toggleActions() {
        this.showActions = !this.showActions;
    },
    async checkAll() {
      const ids = await api.media.matching(this.filter);
      this.selectedIds = new Set(ids.data);
    },
    setTagStates(tags) {
      console.log("add tags:", tags);
      this.tagStates = tags;
    },
    async applyBatchUpdate() {
      if (!this.selectedIds.size) {
        alert("Keine Medien ausgewählt");
        return;
      }
      const data = {
        mediaIds: Array.from(this.selectedIds),
        visibility: this.visibility,
        includeTags: Object.keys(this.tagStates).filter(id => this.tagStates[id] === 1),
        excludeTags: Object.keys(this.tagStates).filter(id => this.tagStates[id] === 2)
      };
      console.log("batch update:", this.tagStates, data);

      await this.batchUpdate(data);
      //   this.load();
      this.selectedIds = new Set();
      this.tagStates = {};
      this.visibility = 0;
    },
    runFilter() {
      this.selectedIds = new Set();
      this.clear();
      this.showFilter = false;
    },
  },
  created() {},
};
</script>

<style lang="less" scoped>
.media-admin {
  padding: 1em;
  color: black;
  font-size: 3vw;
  overflow: auto;
  flex: 1 0;
  display: flex;
  flex-flow: column;
  .actions {
    margin-top: 1em;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
.buttons {
  display: flex;
  flex-flow: row;
  justify-content: flex-start;
  font-size: 3vw;
  color: black;
  align-items: center;
  margin:1vw 0;

}
.button { margin-right: 1vw; }
.filter-panel {
  margin-bottom: 1rem;
  padding: 1rem;
  background: #eee;
  border: 1px solid #ccc;
  border-radius: 4px;
}
</style>
